/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Table, Checkbox, Dimmer, Segment, Divider, Form,
  Button, Icon, Modal, Loader, Popup, Grid
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

let formInput = "";

let tableStyle = {
  overflowY: "scroll",
  maxHeight: "30vh"
};

class Blacklist extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      devices: [],
      originalDevices: [],

      isInBlacklistList: [],
      isInAutomaticBlacklistList: [],

      column: null,
      sortDirection: "ascending",
      isColumnClicked: false,

      showConfirmUpdateBlacklistModal: false,

      isUpdatingBlacklistDimmerActive: false,

      isAlterBlacklistModalOpen: false,
      isSendingDataDimmerActive: false
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        devices: data.sort(UtilsInstance.sortBy("address", false, parseInt)),
        originalDevices: data.sort(UtilsInstance.sortBy("address", false, parseInt))
      }, () => {
        this.buildCheckedList();
      }));
  }

  buildCheckedList = () => {
    let isInBlacklist = [];
    let isInAutomaticBlacklist = [];

    for (let i = 0; i < this.state.devices.length; i++) {
      isInBlacklist[this.state.devices[i].address] = this.state.devices[i].isInBlacklist;
      isInAutomaticBlacklist[this.state.devices[i].address] = this.state.devices[i].isInAutomaticBlacklist;
    }

    this.setState({
      isInBlacklistList: isInBlacklist,
      isInAutomaticBlacklistList: isInAutomaticBlacklist,
    });

  }

  buildDeviceRows = (device) => {
    if (device.status !== Constants.MASTER) {
      return (
        <Table.Row key={device.address} textAlign="center" verticalAlign="middle">
          <Table.Cell width="1" verticalAlign="middle">{device.address}</Table.Cell>
          <Table.Cell width="2" verticalAlign="middle">{device.tag}</Table.Cell>
          <Table.Cell width="2" verticalAlign="middle">{device.model}</Table.Cell>
          <Table.Cell width="1">
            <Checkbox
              checked={this.state.isInBlacklistList[device.address]}
              onChange={() => { this.toggleIsInBlacklistCheckbox(device.address); }}
            />
          </Table.Cell>
          <Table.Cell width="1">
            {this.getAutomaticBlacklistCheckbox(device)}
          </Table.Cell>
        </Table.Row>
      );
    }
  }

  // ------ Toggle Checkboxes ---------
  toggleIsInBlacklistCheckbox = (address) => {
    let isInBlacklistListCopy = this.state.isInBlacklistList;

    isInBlacklistListCopy[address] = !isInBlacklistListCopy[address];

    this.setState({ isInBlacklistList: isInBlacklistListCopy });
  }

  toggleIsInAutomaticBlacklistCheckbox = (address) => {
    let isInAutomaticBlacklistListCopy = this.state.isInAutomaticBlacklistList;

    isInAutomaticBlacklistListCopy[address] = !isInAutomaticBlacklistListCopy[address];

    this.setState({ isInAutomaticBlacklistList: isInAutomaticBlacklistListCopy });
  }

  getAutomaticBlacklistCheckbox = (device) => {
    if (device.isInAutomaticBlacklist === true) {
      return (
        <Checkbox
          checked={this.state.isInAutomaticBlacklistList[device.address]}
          onChange={() => { this.toggleIsInAutomaticBlacklistCheckbox(device.address); }} />
      );
    }
    else {
      return (
        <Checkbox disabled />
      );
    }
  }

  // ------ Sort ---------
  handleBlacklistSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order the blacklist by address ascending
    if (clickedColumn === "address" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the blacklist by address descending
    else if (clickedColumn === "address" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the blacklist by tag ascending
    else if (clickedColumn === "tag" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the blacklist by tag descending
    else if (clickedColumn === "tag" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the blacklist by model ascending
    else if (clickedColumn === "model" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "model",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the blacklist by model descending
    else if (clickedColumn === "model" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "model",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
  }

  // ------ Search ---------
  handleFormChange = (event, data) => {
    formInput = data.value;
  };

  handleSearch = () => {
    let searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {

      let upperFormInput = formInput.toUpperCase();

      let deviceAddress = this.state.originalDevices[i].address.toString();
      let upperTag = "";
      let upperModel = "";

      if (this.state.originalDevices[i].tag !== undefined
        && this.state.originalDevices[i].tag !== null) {
        upperTag = this.state.originalDevices[i].tag.toUpperCase();
      }

      if (this.state.originalDevices[i].model !== undefined
        && this.state.originalDevices[i].model !== null) {
        upperModel = this.state.originalDevices[i].model.toUpperCase();
      }

      if (deviceAddress === upperFormInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
      else if (upperTag.indexOf(upperFormInput) !== -1) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
      else if (upperModel.indexOf(upperFormInput) !== -1) {
        searchedDevices.push(this.state.originalDevices[i]);
      }

      // Reset the list if the user searches with an empty string
      if (upperFormInput === "") {
        this.setState({ devices: this.state.originalDevices });
      }
      else {
        this.setState({ devices: searchedDevices });
      }
    }
  }

  adjustTableMaxHeight = (browserHeight) => {
    if (browserHeight < 600) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "40vh"
      };
    }
    else if (browserHeight >= 600 && browserHeight < 650) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "42vh"
      };
    }
    else if (browserHeight >= 650 && browserHeight < 700) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "42vh"
      };
    }
    else if (browserHeight >= 700 && browserHeight < 800) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "45.5vh"
      };
    }
    else if (browserHeight >= 800 && browserHeight < 900) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "45.5vh"
      };
    }
    else {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "49vh"
      };
    }
  }

  // -------- Send Info --------
  closeAlterBlacklistModal = () => {
    this.setState({ isAlterBlacklistModalOpen: false });
  }

  openAlterBlacklistModal = () => {
    this.setState({ isAlterBlacklistModalOpen: true });
  }

  handleAlterBlacklistSubmit = () => {
    // First thign to do is close the modal and show the loading dimmer
    this.closeAlterBlacklistModal();
    this.setState({ isSendingDataDimmerActive: true });

    // We will send all the addresses in hexadecimal format
    let hexAddToBlacklistAddressesToSend = { devices: [] };
    let hexRemoveFromBlacklistAddressesToSend = { devices: [] };
    let hexRemoveFromAutomaticBlacklistAddressesToSend = { devices: [] };

    for (let i = 0; i < this.state.isInBlacklistList.length; i++) {
      if (this.state.isInBlacklistList[i] === true) {
        hexAddToBlacklistAddressesToSend.devices.push(i.toString(16));
      }
      else if (this.state.isInBlacklistList[i] === false) {
        hexRemoveFromBlacklistAddressesToSend.devices.push(i.toString(16));
      }
    }

    for (let i = 0; i < this.state.isInAutomaticBlacklistList.length; i++) {
      if (this.state.isInAutomaticBlacklistList[i] === false) {
        hexRemoveFromAutomaticBlacklistAddressesToSend.devices.push(i.toString(16));
      }
    }

    let addToBlacklistData = JSON.stringify(hexAddToBlacklistAddressesToSend);
    let removeFromBlacklistData = JSON.stringify(hexRemoveFromBlacklistAddressesToSend);
    let removeFromAutomaticBlacklistData = JSON.stringify(hexRemoveFromAutomaticBlacklistAddressesToSend);

    // Frist try to add the devices to the blacklist
    fetch(Constants.REQUEST_IP_ADDRESS + "addToBlacklist_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: addToBlacklistData,
      mode: "cors"
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        // Then try to remove the ones that are not on the blacklist
        fetch(Constants.REQUEST_IP_ADDRESS + "removeFromBlacklist_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: removeFromBlacklistData,
          mode: "cors"
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            // Finally try to remove the ones that are not on the automatic blacklist
            fetch(Constants.REQUEST_IP_ADDRESS + "removeFromAutomaticBlacklist_POST", {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              },
              body: removeFromAutomaticBlacklistData,
              mode: "cors"
            })
              .then(UtilsInstance.checkStatus)
              .then(() => {
                alert(Strings.UPDATES_SUCCESS);
              })
              .catch((error) => {
                alert(Strings.REMOVE_CRITIC_DEVICES_FROM_BLACKLIST_FAILURE + Strings.REASON + error);
              })
              .finally(this.setState({ isSendingDataDimmerActive: false }));
          })
          .catch((error) => {
            alert(Strings.REMOVE_DEVICES_FROM_BLACKLIST_FAILURE + Strings.REASON + error);
            this.setState({ isSendingDataDimmerActive: false });
          });
      })
      .catch((error) => {
        alert(Strings.ADD_DEVICES_TO_BLACKLIST_FAILURE + Strings.REASON + error);
        this.setState({ isSendingDataDimmerActive: false });
      });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;

    const deviceRows = this.state.devices.map(device => (
      this.buildDeviceRows(device)
    ));

    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    this.adjustTableMaxHeight(browserHeight);

    return (
      <div>
        <Segment style={segmentStyle}>
          <Divider horizontal style={dividerStyle}>{Strings.BLACKLIST_STRING}</Divider>

          <Grid columns="equal" textAlign="center" verticalAlign="middle">
            <Grid.Row>
              <Grid.Column>
              </Grid.Column>

              <Grid.Column>
                <Form style={searchStyle} onSubmit={this.handleSearch} >
                  <Form.Input
                    placeholder={Strings.BLACKLIST_FORM_INPUT_PLACEHOLDER}
                    id="input-form"
                    icon="search"
                    name="formInput"
                    onChange={this.handleFormChange} />
                </Form>
              </Grid.Column>

              <Grid.Column>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <Table striped celled textAlign="center" fixed sortable style={tableHeaderStyle}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width="1"
                  sorted={column === "address" ? direction : null}
                  onClick={this.handleBlacklistSort("address")}>
                  {Strings.BLACKLIST_ADDRESS}
                </Table.HeaderCell>

                <Table.HeaderCell
                  width="2"
                  sorted={column === "tag" ? direction : null}
                  onClick={this.handleBlacklistSort("tag")}>
                  {Strings.BLACKLIST_TAG}
                </Table.HeaderCell>

                <Table.HeaderCell
                  width="2"
                  sorted={column === "model" ? direction : null}
                  onClick={this.handleBlacklistSort("model")}>
                  {Strings.BLACKLIST_MODEL}
                </Table.HeaderCell>

                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      width="1"
                      disabled>
                      {Strings.BLACKLIST_STRING}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <p>{Strings.BLACKLIST_HEADER_CELL_POPUP}</p>
                    <p>{Strings.BLACKLIST_HEADER_CELL_POPUP_2}</p>
                  </Popup.Content>
                </Popup >

                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      width="1"
                      disabled>
                      {Strings.BLACKLIST_CRITICAL_SLAVE}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <p>{Strings.AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP}</p>
                    <p>{Strings.AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_2}</p>
                    <p>{Strings.AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_3}</p>
                  </Popup.Content>
                </Popup >

              </Table.Row>
            </Table.Header>
          </Table>

          <div style={tableStyle}>
            <Table striped celled textAlign="center" fixed>
              <Table.Body>{deviceRows}</Table.Body>
            </Table>
          </div>

          <Button style={buttonStyle} color="teal" content={Strings.UPDATE_BLACKLIST} onClick={this.openAlterBlacklistModal} />

          <Modal centered open={this.state.isAlterBlacklistModalOpen} size='small' style={notIEModalStyle}>
            <Modal.Content>
              <p>{Strings.CONFIRM_ALTER_BLACKLIST}</p>
            </Modal.Content>
            <Modal.Actions>
              <Button color='red' onClick={this.closeAlterBlacklistModal}><Icon name='remove' />{Strings.NO}</Button>
              <Button color='green' onClick={this.handleAlterBlacklistSubmit}><Icon name='checkmark' />{Strings.YES}</Button>
            </Modal.Actions>
          </Modal>

          <Dimmer active={this.state.isSendingDataDimmerActive} >
            <Loader>{Strings.UPDATING_BLACKLIST_DATA}</Loader>
          </Dimmer>

        </Segment>
      </div>
    );
  }
}

const searchStyle = {
  margin: "0 auto"
};

const dividerStyle = {
  marginTop: "2vh",
  marginLeft: "auto",
  marginRight: "auto"
};

const buttonStyle = {
  width: "50%",
  marginTop: "2vh"
};

const tableHeaderStyle = {
  width: "99.5%"
};

const segmentStyle = {
  textAlign: "center"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const notIEModalStyle = {
  height: "125px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "40vh"
};

export default withRouter(Blacklist);
